import { defineComponent as _defineComponent } from 'vue'
import { resolveComponent as _resolveComponent, createVNode as _createVNode, createElementVNode as _createElementVNode, toDisplayString as _toDisplayString, withCtx as _withCtx, unref as _unref, openBlock as _openBlock, createBlock as _createBlock, createCommentVNode as _createCommentVNode, createElementBlock as _createElementBlock, renderList as _renderList, Fragment as _Fragment, withModifiers as _withModifiers, createTextVNode as _createTextVNode, normalizeClass as _normalizeClass } from "vue"

const _hoisted_1 = { class: "school-group-container" }
const _hoisted_2 = { class: "form-card-tabs-container px-44" }
const _hoisted_3 = { class: "h-5 w-4 [&>svg]:stroke-current [&>svg]:h-5" }
const _hoisted_4 = { class: "text-gray-700 text-2xl font-normal border-b-[1px] border-gray-300 pb-3" }
const _hoisted_5 = { class: "columns-2 mt-6" }
const _hoisted_6 = { class: "text-dark-grey font-medium text-2xl my-6" }
const _hoisted_7 = /*#__PURE__*/_createElementVNode("hr", null, null, -1)
const _hoisted_8 = {
  key: 1,
  class: "flex items-center justify-center py-8 bg-white p-6"
}
const _hoisted_9 = { class: "absolute right-[-2rem] top-8" }
const _hoisted_10 = {
  key: 0,
  class: "relative top-2"
}
const _hoisted_11 = ["onClick"]
const _hoisted_12 = { class: "absolute right-[-2rem] top-8" }
const _hoisted_13 = ["onClick"]
const _hoisted_14 = { class: "flex justify-between items-center mt-4" }
const _hoisted_15 = { class: "h-5 w-5 shrink-0 text-gray-600 [&>svg]:stroke-current [&>svg]:h-5 [&>svg]:w-5" }
const _hoisted_16 = { class: "font-semibold text-sm text-gray-600" }
const _hoisted_17 = ["disabled"]
const _hoisted_18 = { class: "font-semibold text-sm" }
const _hoisted_19 = {
  key: 0,
  class: "flex items-center justify-center gap-x-1"
}
const _hoisted_20 = { key: 1 }
const _hoisted_21 = { class: "p-4" }
const _hoisted_22 = { class: "mx-auto flex items-center justify-center" }
const _hoisted_23 = { class: "bg-red-300 rounded-full p-3 !text-white" }
const _hoisted_24 = { class: "mt-5 text-center" }
const _hoisted_25 = { class: "text-center" }
const _hoisted_26 = { class: "text-sm text-gray-600 mb-8" }
const _hoisted_27 = { class: "mt-6 flex justify-around items-center flex-row" }
const _hoisted_28 = { class: "flex flex-row items-center justify-center w-full" }
const _hoisted_29 = {
  key: 0,
  class: "ml-2"
}

import { Admin } from '@/interfaces/admin.interface';
import { computed, onMounted, ref, watch } from 'vue';
import { FormKitNode } from '@formkit/core';
import { useSchoolGroupStore } from '@/stores/schoolGroupsStore';
import { useAdminStore } from '@/stores/adminStore';
import { useSchoolStore } from '@/stores/schoolStore';
import { useFilterStore } from '@/stores/filterStore';
import { useUserStore } from '@/stores/userStore';
import { TrashIcon } from "@heroicons/vue/24/outline";
import SchoolGroupFreshchatSettingsCard from "@/modules/main/components/internal-tools/SchoolGroupFreshchatSettingsCard.vue";
import SchoolGroupPhaseProgressionSettingsCard from "@/modules/main/components/internal-tools/SchoolGroupPhaseProgressionSettingsCard.vue";
import i18n from '@/plugins/i18n';
import { CheckCircleIcon, ExclamationCircleIcon } from "@heroicons/vue/20/solid";
import { showToast } from '@/utils/toastUtils';
import { useI18n } from 'vue-i18n'

import { defaultSchoolGroup, defaultNewSchoolGroupAdmin  } from "@/modules/main/components/constants/defaults";


export default /*#__PURE__*/_defineComponent({
  __name: 'EditSchoolGroupComponent',
  emits: ["updateValue"],
  setup(__props, { emit: emits }) {

/* eslint-disable @typescript-eslint/no-explicit-any */
const { t } = useI18n();


function notifySuccessGroupDeleteChamp() {
  showToast({
    text: t('internal_view.delete_champion_success'),
    type: 'success',
    icon: CheckCircleIcon,
  })
}

function notifyErrorGroupDeleteChamp() {
  showToast({
    text: t('internal_view.delete_champion_error'),
    type: 'error',
    icon: ExclamationCircleIcon,
  })
}

function notifySuccessGroupAddChamp() {
  showToast({
    text: t('internal_tools.success.school_group_update'),
    type: 'success',
    icon: CheckCircleIcon,
  })
}

const schoolStore = useSchoolStore();
const adminStore = useAdminStore();
const filterStore = useFilterStore();
const schoolGroupStore = useSchoolGroupStore();
const userStore = useUserStore();

const schoolGroup = ref({ ...defaultSchoolGroup });
const originalSchoolGroup = ref({ ...defaultSchoolGroup });
const newSchoolGroupAdmin = ref({ ...defaultNewSchoolGroupAdmin }) as any;
const newSchoolGroupAdmins = ref<Admin[]>([]);
const buttonIsDisabled = ref(false); 
const updateSuccess = ref(false);
const responseMessage = ref("");
const confirmChampionDeletionModal = ref(false);
const adminToDelete = ref<Admin | null>(null);
const deleteChampSuccess = ref(false);
const showChampionDeleteNotification = ref(false);



const previewStep = () => {
    emits("updateValue", false);
};

const hasChanges = computed(() => {
  return JSON.stringify(schoolGroup.value) !== JSON.stringify(originalSchoolGroup.value);
});

const isButtonDisabled = computed(() => {
  return (
    adminStore.loader.creatingAdmin ||
    schoolStore.updateLoader ||
    newSchoolGroupAdmins.value.length === 0 ||
    buttonIsDisabled.value
  );
});

const changedFields = computed(() => {
  const updatedFields: Record<string, unknown> = {};

  if (schoolGroup.value.name !== originalSchoolGroup.value.name) {
    updatedFields.name = schoolGroup.value.name;
  }

  if (schoolGroup.value.description !== originalSchoolGroup.value.description) {
    updatedFields.description = schoolGroup.value.description;
  }

  return updatedFields;
});

const saveChanges = async () => {
    let schoolGroupChampionsCount = 0;
    //clear message and visibility
    responseMessage.value = "";
    updateSuccess.value = false;
    buttonIsDisabled.value = true;

    if (newSchoolGroupAdmins.value.length > 0) {
        for (const admin of newSchoolGroupAdmins.value) {
            // Check if all necessary fields are filled
            if (admin.firstName && admin.lastName && admin.email) {
                // Validate email format
                if (!admin.email) {
                    console.error(`Invalid email format: ${admin.email}`);
                    // Skip this admin if the email is invalid
                    continue; 
                }

                // Add school group key to admin
                admin.schoolGroup = filterStore.selectedFilters.schoolGroup as string;

                console.log("Creating new school group champion:", admin);
                // Create a new school group admin
                const res = await schoolGroupStore.createNewAdmin(admin as any);

                if (res) {
                    // Add champion to state
                    schoolGroupStore.addSchoolGroupChampion(res);

                    // Increment counter for successful admin creation
                    schoolGroupChampionsCount++;
                } else {
                    console.error(`Failed to create admin: ${JSON.stringify(admin)}`);
                }
            } else {
                console.log("School group champion data is incomplete:", admin);
            }
        }
    }

    if (hasChanges.value) {

        const schoolGroupId = filterStore.selectedFilters.schoolGroup;
        const response = await schoolGroupStore.updateSchoolGroup(schoolGroupId, changedFields.value);

        if (response) {

            console.log("School group updated successfully:", response);
            filterStore.updateSchoolGroup(response);

            // Update the original reference to prevent duplicate changes
            originalSchoolGroup.value = { ...schoolGroup.value };

            // Show success message (optional)
            responseMessage.value = i18n.global
            .t("internal_tools.success.school_group_update")
            .toString();
            updateSuccess.value = true;
            notifySuccessGroupAddChamp();
        }
    }

    // Display success message only if champions were created
    if (schoolGroupChampionsCount > 0) {
        responseMessage.value += "<br/>" + i18n.global
            .t("internal_tools.success.champions_message")
            .toString();
        updateSuccess.value = true;
        notifySuccessGroupAddChamp();

        console.log(`${schoolGroupChampionsCount} school group champion(s) successfully created.`);
    } else {
        console.log("No school group champions were created.");
    }

    if (updateSuccess.value) {
        // Fetch the updated school group details
        getSchoolGroupDetails();
    }
    
    // Re-enable the button after processing
    buttonIsDisabled.value = false; 
    // Clear the form regardless of the result
    clearData();

};

const removeSchoolGroupChampion = (index: number) => {
  newSchoolGroupAdmins.value.splice(index, 1);
};

const addSchoolGroupChampion = () => {
  // Spread newAdmin to create a new instance and generate a unique _id
  newSchoolGroupAdmins.value.push({
    ...newSchoolGroupAdmin.value,
    _id: Math.random().toString(36).substring(2) + Date.now().toString(36),
  });
}; 

const email_exists = async (node: FormKitNode): Promise<boolean> => {
  try {
    const emailExists = await schoolStore?.validateEmail(node.value as string);
    buttonIsDisabled.value = emailExists; // Disable button if email exists
    return !emailExists; // Validation passes if email does not exist
  } catch (error) {
    buttonIsDisabled.value = true; // Disable on error
    return true;
  }
};

const getSchoolGroupDetails = async () => {

  const schoolGroupId = filterStore.selectedFilters.schoolGroup;

  if (!schoolGroupId) return;

  const foundGroup = await schoolGroupStore.fetchSchooGroupById(schoolGroupId);
  if (!foundGroup) return;

  const group = schoolGroupStore.activeSchoolGroup ?? { name: '', description: '' };

  // Update school group data
  schoolGroup.value = { name: group.name, description: group.description };

  // Store original values for tracking changes
  originalSchoolGroup.value = { name: group.name, description: group.description };
};

const clearData = () => {
    // Clear the newSchoolGroupAdmins array
    newSchoolGroupAdmins.value = [];
};

onMounted(async()=>{
  // school grooup details
 await getSchoolGroupDetails();
});

const showConfirmChampionDeletionModal = (admin: Admin, e: Event) => {
  // stop page refresh
  e.preventDefault();
  
  confirmChampionDeletionModal.value = true;
  adminToDelete.value = admin;
};

const canceldeletion = () => {
  confirmChampionDeletionModal.value = false;
};

const removeExistingChampion = async (admin: Admin, e: Event) => {
  // stop page refresh
  e.preventDefault();
  deleteChampSuccess.value = false;

  // get the selected champion's id
  const championId = admin._id;

  //  use new action to delete the champion
  if (championId) {
    const deletedChampion = await adminStore.deleteExistingChampion(championId, filterStore.selectedFilters.schoolGroup, "school");
    deleteChampSuccess.value = deletedChampion;
    showChampionDeleteNotification.value = deletedChampion;
    notifySuccessGroupDeleteChamp();
  } else {
    console.error("Champion ID is undefined");
    deleteChampSuccess.value = false;
    notifyErrorGroupDeleteChamp();
  }

  confirmChampionDeletionModal.value = false;
};

// Watcher to detect changes
watch(
  () => schoolGroup.value,
  () => {
    console.log("School Group Changed:", schoolGroup.value);
    updateSuccess.value = false;
  },
  { deep: true }
);

watch(() => filterStore.selectedFilters.schoolGroup, getSchoolGroupDetails);

return (_ctx: any,_cache: any) => {
  const _component_rl_icon = _resolveComponent("rl-icon")!
  const _component_FormKit = _resolveComponent("FormKit")!
  const _component_spinner_loader = _resolveComponent("spinner-loader")!
  const _component_DialogTitle = _resolveComponent("DialogTitle")!
  const _component_modal = _resolveComponent("modal")!

  return (_openBlock(), _createElementBlock(_Fragment, null, [
    _createElementVNode("div", _hoisted_1, [
      _createElementVNode("div", _hoisted_2, [
        _createElementVNode("button", {
          onClick: _cache[0] || (_cache[0] = ($event: any) => (previewStep())),
          type: "submit",
          class: "font-semibold text-gray-700 my-4 text-base border-gray-300 border rounded-lg py-2 px-4 flex items-center shadow-[0px_1px_2px_0px_rgba(16,24,40,0.05)] bg-white gap-2"
        }, [
          _createElementVNode("span", _hoisted_3, [
            _createVNode(_component_rl_icon, {
              icon: 'rl-small-back-arrow',
              title: 'rl small back arrow',
              "aria-hidden": "true"
            })
          ]),
          _createElementVNode("span", null, _toDisplayString(_ctx.$t('internal_tools.school_group.btn_back')), 1)
        ]),
        _createVNode(_component_FormKit, {
          type: "form",
          id: "school-group",
          class: "group-details-form",
          actions: false
        }, {
          default: _withCtx(() => [
            _createElementVNode("h2", _hoisted_4, _toDisplayString(_ctx.$t('internal_tools.school_group.group_details')), 1),
            _createElementVNode("div", _hoisted_5, [
              _createVNode(_component_FormKit, {
                type: "text",
                label: _ctx.$t('internal_tools.school_group.group_name'),
                "outer-class": "primary-select-clear formkit-messages-edit",
                placeholder: _ctx.$t('internal_tools.school_group.type_here'),
                modelValue: schoolGroup.value.name,
                "onUpdate:modelValue": _cache[1] || (_cache[1] = ($event: any) => ((schoolGroup.value.name) = $event)),
                validation: "required",
                "validation-messages": {
                            required: _ctx.$t('internal_tools.school_group.group_name_validation')
                        }
              }, null, 8, ["label", "placeholder", "modelValue", "validation-messages"]),
              _createVNode(_component_FormKit, {
                type: "text",
                label: _ctx.$t('internal_tools.school_group.group_description'),
                "outer-class": "primary-select-clear formkit-messages-edit",
                "inner-class": "bg-white",
                placeholder: _ctx.$t('internal_tools.school_group.type_here'),
                modelValue: schoolGroup.value.description,
                "onUpdate:modelValue": _cache[2] || (_cache[2] = ($event: any) => ((schoolGroup.value.description) = $event)),
                validation: "required",
                "validation-messages": {
                            required: _ctx.$t('internal_tools.school_group.group_description_validation')
                        }
              }, null, 8, ["label", "placeholder", "modelValue", "validation-messages"])
            ])
          ]),
          _: 1
        }),
        _createVNode(SchoolGroupFreshchatSettingsCard),
        (_unref(userStore).isInternalAdmin)
          ? (_openBlock(), _createBlock(SchoolGroupPhaseProgressionSettingsCard, { key: 0 }))
          : _createCommentVNode("", true),
        _createElementVNode("h1", _hoisted_6, _toDisplayString(_ctx.$t("internal_tools.single_school_component.title")), 1),
        _hoisted_7,
        (_unref(schoolGroupStore).schoolGroupByIdLoader === true || _unref(schoolGroupStore).loader.creatingAdmin == true)
          ? (_openBlock(), _createElementBlock("div", _hoisted_8, [
              _createVNode(_component_spinner_loader, { color: 'text-blue-600 dark:text-blue-600' })
            ]))
          : (_openBlock(true), _createElementBlock(_Fragment, { key: 2 }, _renderList(_unref(schoolGroupStore)?.activeSchoolGroup?.schoolGroupChampions, (admin) => {
              return (_openBlock(), _createElementBlock("div", {
                key: admin._id,
                class: "columns-5 mt-4 mb-2 relative"
              }, [
                _createVNode(_component_FormKit, {
                  type: "text",
                  label: _ctx.$t('internal_tools.form.champion_name'),
                  placeholder: _ctx.$t('internal_tools.form.champion_name'),
                  modelValue: admin.firstName,
                  "onUpdate:modelValue": ($event: any) => ((admin.firstName) = $event),
                  disabled: "true",
                  style: { position: 'relative' },
                  "messages-class": 'absolute'
                }, null, 8, ["label", "placeholder", "modelValue", "onUpdate:modelValue"]),
                _createVNode(_component_FormKit, {
                  type: "text",
                  label: _ctx.$t('internal_tools.form.champion_surname'),
                  placeholder: _ctx.$t('internal_tools.form.champion_surname'),
                  modelValue: admin.lastName,
                  "onUpdate:modelValue": ($event: any) => ((admin.lastName) = $event),
                  disabled: "true",
                  style: { position: 'relative' },
                  "messages-class": 'absolute'
                }, null, 8, ["label", "placeholder", "modelValue", "onUpdate:modelValue"]),
                _createVNode(_component_FormKit, {
                  type: "email",
                  label: _ctx.$t('internal_tools.form.champion_email'),
                  placeholder: _ctx.$t('internal_tools.form.champion_email'),
                  modelValue: admin.email,
                  "onUpdate:modelValue": ($event: any) => ((admin.email) = $event),
                  disabled: "true",
                  style: { position: 'relative' },
                  validation: "required|email|(500)email_exists",
                  "validation-rules": { email_exists: email_exists },
                  "validation-messages": {
                    email_exists: _ctx.$t(
                    'add_grades_class_component.step_1.email_exists'
                    ),
                    email: _ctx.$t(
                    'add_grades_class_component.step_1.invalid_email'
                    )
                },
                  "messages-class": 'absolute'
                }, null, 8, ["label", "placeholder", "modelValue", "onUpdate:modelValue", "validation-rules", "validation-messages"]),
                _createVNode(_component_FormKit, {
                  type: "text",
                  label: _ctx.$t('internal_tools.form.champion_title'),
                  placeholder: _ctx.$t('internal_tools.form.champion_title'),
                  disabled: "true",
                  modelValue: admin.designation,
                  "onUpdate:modelValue": ($event: any) => ((admin.designation) = $event)
                }, null, 8, ["label", "placeholder", "modelValue", "onUpdate:modelValue"]),
                _createVNode(_component_FormKit, {
                  type: "number",
                  label: _ctx.$t('internal_tools.form.champion_phone'),
                  placeholder: _ctx.$t('internal_tools.form.champion_phone'),
                  modelValue: admin.phoneNumber,
                  "onUpdate:modelValue": ($event: any) => ((admin.phoneNumber) = $event),
                  disabled: "true"
                }, null, 8, ["label", "placeholder", "modelValue", "onUpdate:modelValue"]),
                _createElementVNode("div", _hoisted_9, [
                  (_unref(adminStore).loader.deleteAdmin)
                    ? (_openBlock(), _createElementBlock("div", _hoisted_10, [
                        _createVNode(_component_spinner_loader, { color: 'text-blue-600 dark:text-blue-600' })
                      ]))
                    : (_openBlock(), _createElementBlock("button", {
                        key: 1,
                        onClick: ($event: any) => (showConfirmChampionDeletionModal(admin, $event)),
                        class: "mt-2 text-red-500"
                      }, [
                        _createVNode(_unref(TrashIcon), { class: "h-5 w-5" })
                      ], 8, _hoisted_11))
                ])
              ]))
            }), 128)),
        (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(newSchoolGroupAdmins.value, (admin, index) => {
          return (_openBlock(), _createElementBlock("div", {
            key: admin._id,
            class: "columns-5 mt-4 mb-2 relative"
          }, [
            _createVNode(_component_FormKit, {
              type: "text",
              label: _ctx.$t('internal_tools.form.champion_name'),
              "outer-class": "primary-select",
              placeholder: _ctx.$t('internal_tools.form.champion_name'),
              modelValue: admin.firstName,
              "onUpdate:modelValue": ($event: any) => ((admin.firstName) = $event),
              style: { position: 'relative' },
              validation: "required",
              "messages-class": 'absolute'
            }, null, 8, ["label", "placeholder", "modelValue", "onUpdate:modelValue"]),
            _createVNode(_component_FormKit, {
              type: "text",
              label: _ctx.$t('internal_tools.form.champion_surname'),
              "outer-class": "primary-select",
              placeholder: _ctx.$t('internal_tools.form.champion_surname'),
              modelValue: admin.lastName,
              "onUpdate:modelValue": ($event: any) => ((admin.lastName) = $event),
              style: { position: 'relative' },
              validation: "required",
              "messages-class": 'absolute'
            }, null, 8, ["label", "placeholder", "modelValue", "onUpdate:modelValue"]),
            _createVNode(_component_FormKit, {
              type: "email",
              label: _ctx.$t('internal_tools.form.champion_email'),
              "outer-class": "primary-select",
              placeholder: _ctx.$t('internal_tools.form.champion_email'),
              modelValue: admin.email,
              "onUpdate:modelValue": ($event: any) => ((admin.email) = $event),
              validation: "required|email|(500)email_exists",
              style: { position: 'relative' },
              "validation-rules": { email_exists: email_exists },
              "validation-messages": {
                    email_exists: _ctx.$t(
                    'add_grades_class_component.step_1.email_exists'
                    ),
                    email: _ctx.$t(
                    'add_grades_class_component.step_1.invalid_email'
                    )
                },
              "messages-class": 'absolute'
            }, null, 8, ["label", "placeholder", "modelValue", "onUpdate:modelValue", "validation-rules", "validation-messages"]),
            _createVNode(_component_FormKit, {
              type: "text",
              label: _ctx.$t('internal_tools.form.champion_title'),
              "outer-class": "primary-select",
              placeholder: _ctx.$t('internal_tools.form.champion_title'),
              readonly: "",
              classes: {
                  input: '!bg-gray-300 cursor-not-allowed'
                },
              modelValue: admin.designation,
              "onUpdate:modelValue": ($event: any) => ((admin.designation) = $event)
            }, null, 8, ["label", "placeholder", "modelValue", "onUpdate:modelValue"]),
            _createVNode(_component_FormKit, {
              type: "number",
              label: _ctx.$t('internal_tools.form.champion_phone'),
              "outer-class": "primary-select",
              placeholder: _ctx.$t('internal_tools.form.champion_phone'),
              modelValue: admin.phoneNumber,
              "onUpdate:modelValue": ($event: any) => ((admin.phoneNumber) = $event)
            }, null, 8, ["label", "placeholder", "modelValue", "onUpdate:modelValue"]),
            _createElementVNode("div", _hoisted_12, [
              _createElementVNode("button", {
                onClick: ($event: any) => (removeSchoolGroupChampion(index)),
                class: "mt-2 text-red-500"
              }, [
                _createVNode(_unref(TrashIcon), { class: "h-5 w-5" })
              ], 8, _hoisted_13)
            ])
          ]))
        }), 128)),
        _createElementVNode("div", _hoisted_14, [
          _createElementVNode("button", {
            class: "flex gap-[6px] items-center pr-4 py-2 rounded-[1.25rem] justify-center text-gray-600",
            onClick: _cache[3] || (_cache[3] = _withModifiers(($event: any) => (addSchoolGroupChampion()), ["prevent"]))
          }, [
            _createElementVNode("span", _hoisted_15, [
              _createVNode(_component_rl_icon, {
                icon: 'rl-plus',
                title: 'rl plus',
                "aria-hidden": "true"
              })
            ]),
            _createElementVNode("h1", _hoisted_16, _toDisplayString(_ctx.$t("add_grades_class_component.step_1.btn_add")), 1)
          ]),
          _createElementVNode("button", {
            class: _normalizeClass([
                            'px-[14px] py-[10px] !text-white bg-blue-600 border border-blue-600 rounded-lg',
                            isButtonDisabled.value && !hasChanges.value ? 'cursor-not-allowed opacity-50' : 'cursor-pointer'
                        ]),
            onClick: saveChanges,
            disabled: isButtonDisabled.value && !hasChanges.value
          }, [
            _createElementVNode("h1", _hoisted_18, [
              (
                        _unref(adminStore).loader.creatingAdmin == true ||
                        _unref(schoolGroupStore).loader.schoolGroupUpdate == true
                    )
                ? (_openBlock(), _createElementBlock("span", _hoisted_19, [
                    _createVNode(_component_spinner_loader, { color: '!text-white dark:text-white' }),
                    _createTextVNode(" " + _toDisplayString(_ctx.$t("internal_tools.form.btnSaving")), 1)
                  ]))
                : (_openBlock(), _createElementBlock("span", _hoisted_20, _toDisplayString(_ctx.$t("internal_tools.form.btnSave")), 1))
            ])
          ], 10, _hoisted_17)
        ])
      ])
    ]),
    _createVNode(_component_modal, {
      showCloseButton: true,
      widthClass: 'max-w-2xl',
      open: confirmChampionDeletionModal.value,
      onLocalModalOpen: _cache[5] || (_cache[5] = ($event: any) => (confirmChampionDeletionModal.value = $event))
    }, {
      default: _withCtx(() => [
        _createElementVNode("div", _hoisted_21, [
          _createElementVNode("div", _hoisted_22, [
            _createElementVNode("div", _hoisted_23, [
              _createVNode(_unref(TrashIcon), { class: "h-6 w-6" })
            ])
          ]),
          _createElementVNode("div", _hoisted_24, [
            _createVNode(_component_DialogTitle, {
              as: "h3",
              class: "text-lg font-semibold text-gray-900 mb-1"
            }, {
              default: _withCtx(() => [
                _createTextVNode(_toDisplayString(_ctx.$t("internal_tools.school_champions.modal.confirm_title")), 1)
              ]),
              _: 1
            })
          ]),
          _createElementVNode("div", _hoisted_25, [
            _createElementVNode("p", _hoisted_26, _toDisplayString(_ctx.$t("internal_tools.school_group.confirm_text")) + ". ", 1)
          ]),
          _createElementVNode("div", _hoisted_27, [
            _createElementVNode("button", {
              type: "button",
              class: "text-gray-700 border border-gray-300 text-sm font-semibold px-4 py-2.5 bg-white rounded-lg mr-3 items-center flex-wrap w-full",
              onClick: canceldeletion
            }, _toDisplayString(_ctx.$t("internal_tools.school_champions.modal.back")), 1),
            _createElementVNode("button", {
              type: "button",
              class: "!text-white border border-blue-600 bg-blue-600 text-sm font-semibold px-4 py-2.5 rounded-lg items-center flex-wrap w-full flex gap-2 justify-center",
              onClick: _cache[4] || (_cache[4] = ($event: any) => (adminToDelete.value && removeExistingChampion(adminToDelete.value, $event)))
            }, [
              _createElementVNode("div", _hoisted_28, [
                _createTextVNode(_toDisplayString(_ctx.$t("internal_tools.school_champions.modal.confirm_btn")) + " ", 1),
                (_unref(adminStore).loader.deleteAdmin)
                  ? (_openBlock(), _createElementBlock("div", _hoisted_29, [
                      _createVNode(_component_spinner_loader, { color: 'text-white dark:text-white' })
                    ]))
                  : _createCommentVNode("", true)
              ])
            ])
          ])
        ])
      ]),
      _: 1
    }, 8, ["open"])
  ], 64))
}
}

})